import React from 'react';
import WeatherApp from './components/WeatherApp';
import './App.css';

function App() {
  return (
    <div className="App">
      <WeatherApp />
    </div>
  );
}

export default App;
